import { BasketOrder } from './basket-order.model';
import { TransportOrderView } from './transport-order-view.model';

export class ConfirmationViewDto {
  basketOrder?: BasketOrder;
  transportOrders: TransportOrderView[] = [];
  totalPrice!: number;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.transportOrders = (data.transportOrders || []).map((to: any) => new TransportOrderView(to));
    this.basketOrder = data.basketOrder ? new BasketOrder(data.basketOrder) : undefined;
  }

  get basePrice(): number {
    return this.transportOrders.reduce((price, it) => price + it.transportPrice, 0);
  }

  get pricingOptions(): number {
    return this.transportOrders.reduce((price, it) => price + (it.priceHT - it.transportPrice - it.insurance), 0);
  }
}
